<div class="dashboard-connect-bank-account-dialog">
  <div class="close-dialog-holder">
    <button
      mat-icon-button
      [mat-dialog-close]="false"
      type="button"
      class="close-dialog-button">
      <mat-icon>clear</mat-icon>
    </button>
  </div>
  <div class="dashboard-connect-bank-account-dialog-container">
    <div class="onboarding-component connect-bank-account-error">
      <img
        [src]="
          themesService.isFathomTheme
            ? 'assets/img/onboarding/exclamation-error-fathom.svg'
            : 'assets/img/onboarding/exclamation-error.svg'
        "
        class="error-image"
        alt="Something went wrong" />

      <h1>
        {{
          'onboarding-connect-bank-account-error.component.header_text'
            | localise
              : 'Oops! It looks like something went wrong while connecting your bank account.'
        }}
      </h1>

      <p class="onboarding-component-subtext"></p>

      <div class="onboarding-component-buttons">
        <button
          class="p-button p-button--rounded p-button--application-next"
          [disabled]="loading"
          (click)="connectBankAccount()">
          {{
            'onboarding-connect-bank-account-error.component.try_again_button'
              | localise: 'Try again'
          }}
        </button>

        <button
          class="mat-button mat-button-base p-button"
          [disabled]="loading"
          (click)="addBankAccountManually()">
          {{
            'onboarding-connect-bank-account-error.component.add_account_manually_button'
              | localise: 'Add account manually'
          }}
        </button>
      </div>
    </div>
  </div>
</div>
